import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { IAuth } from "../../interfaces/IAuth";

/** Old /settlement/:id/history link (:id is an invoice id) → the invoice details page. */
export const SettlementInvoiceRedirect = () => {
  const { id } = useParams();
  const myBusinessType = useSelector((s: { auth: IAuth }) => s.auth.myBusinessType);
  const base = myBusinessType === "SUPPLIER" ? "/sales-invoice" : "/buyer-invoice";
  return <Navigate to={`${base}/${id}/details`} replace />;
};
